<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a
          href="#"
          @click.prevent="$router.push({ name: 'pickup-card-creation' })"
          class="mr-2"
        >
          <i class="fas fa-arrow-left"></i>
        </a>
        {{ $t('pickupCardCreation.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('pickupCardCreation.pageTitle'),
            href: '/pickup-card-creations'
          },
          {
            text: $t('pickupCardCreation.cardByClass'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>
                    {{ $t('pickupCardCreation.criteria') }}
                  </legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('pickupCardCreation.subProgram')
                      }}</label>
                      <a-select
                        style="width:100%"
                        v-model.number="model.acps_id"
                        :options="sub_programs"
                        @change="fetchClass"
                      ></a-select>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('pickupCardCreation.className')
                      }}</label>
                      <ts-loading-banner :loading="class_fetching">
                        <a-select
                          style="width:100%"
                          v-model.number="model.class_id"
                          :options="class_lists"
                          @change="fetchStudent"
                        ></a-select>
                      </ts-loading-banner>
                      <div class="validate" v-if="errors.has('class_id')">
                        {{ errors.first('class_id') }}
                      </div>
                    </div>
                  </div>
                  <ts-loading-banner :loading="fetching">
                    <div
                      id="container"
                      class="form-group overflow-auto"
                      style="max-height: 47vh;min-height: 30vh"
                    >
                      <table
                        id="list"
                        class="table table-hover ui-table ts-table"
                      >
                        <thead>
                          <tr>
                            <th class="text-center">
                              <ts-checkbox
                                @change="selectAll"
                                v-model="checked_all"
                              ></ts-checkbox>
                            </th>
                            <th class="ts-whitespace-no-wrap">
                              {{ $t('pickupCardCreation.cardNumber') }}
                            </th>
                            <th class="ts-whitespace-no-wrap">
                              {{ $t('pickupCardCreation.nameEn') }}
                            </th>
                            <th class="ts-whitespace-no-wrap">
                              {{ $t('pickupCardCreation.studentName') }}
                            </th>
                            <th class="ts-whitespace-no-wrap">
                              {{ $t('pickupCardCreation.relationship') }}
                            </th>
                          </tr>
                          <tr>
                            <th colspan="5">
                              <input
                                type="text"
                                class="form-control"
                                :placeholder="$t('search')"
                                v-model="searchGuardianText"
                              />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(record, index) in availableStudents"
                            :key="index"
                          >
                            <td class="text-center">
                              <ts-checkbox
                                :value="record.student_pickup_id"
                                v-model="model.selectedGuardian"
                                @change="
                                  model.selectedGuardian.length ==
                                  guardian_lists.length
                                    ? (checked_all = true)
                                    : (checked_all = false)
                                "
                              ></ts-checkbox>
                            </td>
                            <td class="ts-whitespace-no-wrap">
                              {{ record.card_number }}
                            </td>
                            <td class="ts-whitespace-no-wrap">
                              {{ record.guardian }}
                            </td>
                            <td class="ts-whitespace-no-wrap">
                              {{ record.student.full_name_en }}
                            </td>
                            <td class="ts-whitespace-no-wrap">
                              {{ record.relationship }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ts-loading-banner>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="radio radio-css radio-inline">
                        <input
                          v-model="side"
                          type="radio"
                          id="front"
                          :value="'front'"
                        />
                        <label for="front">
                          {{ $t('pickupCardCreation.front') }}
                        </label>
                      </div>
                      <div class="radio radio-css radio-inline">
                        <input
                          v-model="side"
                          type="radio"
                          id="back"
                          :value="'back'"
                        />
                        <label for="back">
                          {{ $t('pickupCardCreation.back') }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        color="primary"
                        @click.prevent="preview"
                        :waiting="printing"
                        :disabled="model.selectedGuardian.length <= 0"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>
                  {{ $t('pickupCardCreation.previewCard') }}
                </legend>
                <ts-preview-pdf v-model="printing" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'cardByClass',
  data() {
    return {
      loading: false,
      printing: false,
      class_fetching: false,
      fetching: false,
      checked_all: false,
      src: '',
      errors: new Errors(),
      sub_programs: [],
      class_lists: [],
      guardian_lists: [],
      searchGuardianText: '',
      side: 'front',
      model: {
        branch_id: null,
        acps_id: null,
        class_id: null,
        selectedGuardian: []
      }
    }
  },
  computed: {
    availableStudents() {
      return this.guardian_lists.filter(s => {
        if (this.searchGuardianText.trim() !== '') {
          return (
            s.guardian
              .toLowerCase()
              .includes(this.searchGuardianText.toLowerCase().trim()) ||
            s.card_number.includes(
              this.searchGuardianText.toLowerCase().trim()
            ) ||
            s.relationship
              .toLowerCase()
              .includes(this.searchGuardianText.toLowerCase().trim()) ||
            s.student.full_name_en
              .toLowerCase()
              .includes(this.searchGuardianText.toLowerCase().trim())
          )
        }

        return this.guardian_lists
      })
    }
  },
  created() {
    this.fetchSubProgram()
  },
  methods: {
    ...mapActions('pickupCardCreation', [
      'getSubProgram',
      'getClass',
      'getGuardian'
    ]),
    fetchSubProgram() {
      this.loading = true
      this.getSubProgram()
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchClass(acps_id) {
      this.model.class_id = null
      this.class_lists = []
      this.guardian_lists = []
      this.model.selectedGuardian = []
      this.class_fetching = true
      this.getClass(acps_id)
        .then(response => {
          this.class_lists = response.data.map(el => ({
            value: el.class_id,
            label: el.class_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.class_fetching = false
        })
    },
    fetchStudent(class_id) {
      this.model.selectedGuardian = []
      this.fetching = true
      this.getGuardian({
        class_id: class_id
      })
        .then(response => {
          this.guardian_lists = []
          this.guardian_lists = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    },
    selectAll(e) {
      if (e) {
        this.model.selectedGuardian = []
        this.guardian_lists.map(el => {
          this.model.selectedGuardian.push(el.student_pickup_id)
          this.checked_all = true
        })
      } else {
        this.model.selectedGuardian = []
      }
    },
    preview() {
      this.printing = true
      this.$store
        .dispatch('pickupCardCreation/printCard', {
          student_pickup_id_list: this.model.selectedGuardian,
          side: this.side
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.printing = false
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.printing = false
        })
    }
  }
}
</script>
<style scoped>
#list > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  padding: 7px;
  border-bottom: none !important;
  z-index: 10;
}
#list > tbody > tr > td {
  padding: 3px;
  vertical-align: bottom;
}
</style>
